// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var BALLOT_DATA_KEY = "ballotData";
export var BALLOT_DATA_EXPIRATION_KEY = "ballotDataExpiration";
export var clearSessionStorageBallotData = function () {
    sessionStorage.removeItem(BALLOT_DATA_KEY);
    sessionStorage.removeItem(BALLOT_DATA_EXPIRATION_KEY);
};
